<template>
  <div class="container">
      <Instance
        v-for="(instance, i) in instances"
        v-bind:key="instance._id"
        v-bind:instance="instance"
        v-bind:instanceIndex="i"
      />
  </div>
</template>


<script>
import Instance from '@/components/Instance.vue'
export default {
  name: 'Instances',
  props: ['instances'],
  components: {
    Instance
  }
}
</script>

<style scoped>
  .container {
    display: inline-block;;
    position: relative;
    width: 100%;
  }
  ul {
    display: inline-block;
    position: relative;
    width: 100%;
    list-style: none;
    margin: 0;
    padding: 0;
  }
</style>